var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-adicionar-pessoa",on:{"click":_vm.adicionarPaciente}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"size":"60","color":"#213848"}},on),[_vm._v("mdi-plus-circle-outline")])]}}])},[_vm._v(" Adicionar paciente ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }